import {useMutation} from '@apollo/react-hooks';

import type {InitiateSsoSetup as InitiateSsoSetupMutation} from 'nutshell-graphql-types';

import INITIATE_SSO_SETUP from '../mutations/initiate-sso-setup.graphql';

export const useInitiateSsoSetup = (): {
    initiateSsoSetup: () => Promise<any>;
} => {
    const [initiateSsoSetup] = useMutation<InitiateSsoSetupMutation, Record<any, any>>(
        INITIATE_SSO_SETUP
    );

    return {
        initiateSsoSetup: () => {
            return initiateSsoSetup();
        },
    };
};
